import { Component, OnInit, HostListener, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { LanguageRoutingService } from '../../services/language-routing.service';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'app-language-dropdown',
  standalone: true,
  imports: [CommonModule, TranslocoModule, ButtonComponent],
  templateUrl: './language-dropdown.component.html',
  styleUrls: ['./language-dropdown.component.scss'],
})
export class LanguageDropdownComponent implements OnInit {
  /** Render as a flat inline list (mobile drawer) instead of a popover. */
  @Input() inline = false;
  isOpen = false;
  languages: { code: string; name: string }[] = [];
  currentLang = 'en';

  // Display names for languages
  langNames: Record<string, string> = {
    en: 'English',
    sk: 'Slovensky',
    cz: 'Česky',
  };

  constructor(private translocoService: TranslocoService, private languageRoutingService: LanguageRoutingService) {}

  ngOnInit(): void {
    // Get supported languages from routing service
    const supportedLangs = this.languageRoutingService.getSupportedLanguages();
    this.languages = supportedLangs.map((lang) => ({
      code: lang,
      name: this.langNames[lang] || lang,
    }));

    // Get current language from routing service
    this.currentLang = this.languageRoutingService.getCurrentLanguage();

    // Subscribe to language changes
    this.translocoService.langChanges$.subscribe((lang) => {
      this.currentLang = lang;
    });
  }

  toggleDropdown(): void {
    this.isOpen = !this.isOpen;
  }

  selectLanguage(lang: string): void {
    // Use language routing service to change language and update URL
    this.languageRoutingService.changeLanguage(lang);
    this.isOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.language-dropdown')) {
      this.isOpen = false;
    }
  }
}
